import {isPlatformBrowser} from '@angular/common';
import {Component, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {
  CmsFlexComponentData
} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {ConfigService, JsonService} from '@dcp/configurator';
import {NgbDropdownItem} from '@ng-bootstrap/ng-bootstrap';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CmsComponentData} from '@spartacus/storefront';
import {filter} from 'rxjs/operators';

export interface ReturnToUrl {
  link?: string;
  title?: string;
}

@UntilDestroy()
@Component({
  selector: 'dcp-return-to',
  templateUrl: './return-to.component.html',
  styleUrls: ['./return-to.component.scss']
})
export class ReturnToComponent implements OnInit {
  @ViewChild(NgbDropdownItem) dropdownItem: NgbDropdownItem;
  componentUrl: ReturnToUrl;
  ariaLabel: string = 'header.aria.returnTo';
  showReturnToCart: boolean;

  private CHECKOUT_PAGE_URL = '/checkout/review-order';
  private CART_PAGE_URL = '/cart';
  private ORDER_CONFIRMATION_PAGE_URL = '/order-confirmation';
  private CART_ARIA_LABEL = 'header.aria.sapStoreCart';
  private CHECKOUT_ARIA_LABEL = 'header.aria.sapStoreCheckout';

  constructor(@Inject(PLATFORM_ID) public platformId: object,
              public router: Router,
              public cmsData: CmsComponentData<CmsFlexComponentData>,
              public jsonService: JsonService,
              public configService: ConfigService) {
  }

  ngOnInit(): void {
    this.updateUi(this.router);
    this.subscribeToComponentData();
    this.subscribeToRouter();
  }

  /**
   * Set showReturnToCart flag if it is Checkout Page. Updates Aria Label
   */
  updateUi(router: Router | NavigationEnd) {
    this.showReturnToCart = router.url?.includes(this.CHECKOUT_PAGE_URL);
    this.updateAriaLabel(router);
  }

  updateAriaLabel(router: Router | NavigationEnd) {
    if (this.checkRoute(router, this.CART_PAGE_URL)) {
      this.ariaLabel = this.CART_ARIA_LABEL;
    } else if (this.checkRoute(router, this.CHECKOUT_PAGE_URL) || this.checkRoute(router, this.ORDER_CONFIRMATION_PAGE_URL)) {
      this.ariaLabel = this.CHECKOUT_ARIA_LABEL;
    }
  }

  private checkRoute(router: Router | NavigationEnd, text: string): boolean {
    return router.url?.includes(text);
  }

  /**
   * Fetches component data from cloud commerce.
   */
  subscribeToComponentData(): void {
    this.cmsData.data$
      .pipe(untilDestroyed(this))
      .subscribe(d => {
        const componentData: { url: any } = this.jsonService.parseSafely(d?.classificationsProductData) as { url: any };
        this.componentUrl = componentData.url;
      });
  }

  subscribeToRouter() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        untilDestroyed(this)
      )
      .subscribe((event: NavigationEnd) => {
        this.updateUi(event);
      });
  }

  onToggle(open: boolean) {
    if (isPlatformBrowser(this.platformId) && open && this.dropdownItem) {
      setTimeout(() => {
        this.dropdownItem.elementRef.nativeElement.focus();
      }, 0);
    }
  }
}
